import { SignInType, type SignInTokens } from '@bbkAdminRedux/rtkq/auth-types';

export type DevSignInArgs = {
  email: string;
  pw: string;
};

type DevTokensResponse = {
  access_token: string;
  refresh_token: string;
  exp: number;
};

type DevErrorResponse = {
  metadata?: {
    error?: {
      type?: string;
    };
  };
};

export class AuthDev {
  public async signIn({ email, pw }: DevSignInArgs): Promise<SignInTokens> {
    const response = await fetch('/dev/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password: pw,
      }),
    });

    const result = (await response.json()) as
      | DevTokensResponse
      | DevErrorResponse;
    if (!response.ok) {
      throw {
        code: (result as DevErrorResponse).metadata?.error?.type,
        message: 'Incorrect username or password.',
      };
    }

    const tokens = result as DevTokensResponse;
    return {
      type: SignInType.DEV,
      access_token: tokens.access_token,
      refresh_token: tokens.refresh_token,
      exp: tokens.exp,
    };
  }
}
